const _BRANCH = process.env.BRANCH;
export default _BRANCH;
